import React from "react";
import styled from "styled-components";
import QuarklycommunityKitYouTube from "./QuarklycommunityKitYouTube";

const toolkitImg = "/assets/toolkit_ru.svg";

const SectionWrapper = styled.section`
    padding: 60px 20px;
    background: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const ShowcaseContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 48px;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    
    @media (max-width: 992px) {
        flex-direction: column;
        gap: 32px;
        text-align: center;
    }
`;

const ContentColumn = styled.div`
    flex: 1.15;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    
    @media (max-width: 992px) {
        align-items: center;
    }
`;

const MediaColumn = styled.div`
    flex: 0.85;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    width: 100%;
    max-width: 440px;
`;

const TabContainer = styled.div`
    display: flex;
    background: rgba(255, 255, 255, 0.03);
    padding: 4px;
    border-radius: 12px;
    width: 100%;
    box-sizing: border-box;
    border: 1px solid rgba(255, 255, 255, 0.08);
`;

const TabButton = styled.button`
    flex: 1;
    background: ${props => props.active ? "rgba(255, 255, 255, 0.08)" : "transparent"};
    color: ${props => props.active ? "#ffffff" : "rgba(255, 255, 255, 0.45)"};
    border: none;
    padding: 10px 14px;
    font-size: 14px;
    font-weight: 700;
    border-radius: 10px;
    cursor: pointer;
    box-shadow: ${props => props.active ? "0 0 12px rgba(168, 85, 247, 0.25)" : "none"};
    transition: all 0.25s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    outline: none;
    
    &:hover {
        color: #ffffff;
    }
    
    &:focus {
        box-shadow: 0 0 0 2px #a855f7;
    }
`;

const ProductTag = styled.span`
    background: rgba(34, 197, 94, 0.15);
    color: #4ade80;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 1.5px;
    padding: 6px 16px;
    border-radius: 100px;
    margin-bottom: 15px;
    border: 1px solid rgba(34, 197, 94, 0.3);
    display: inline-flex;
    align-items: center;
    gap: 6px;
    box-shadow: 0 0 15px rgba(34, 197, 94, 0.1);
    
    &::before {
        content: "";
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #4ade80;
        box-shadow: 0 0 10px #4ade80;
        animation: cdzvPulse 1.5s infinite alternate;
    }
    
    @keyframes cdzvPulse {
        from { opacity: 0.4; transform: scale(0.9); }
        to { opacity: 1; transform: scale(1.1); }
    }
`;

const ProductTitle = styled.h2`
    font-size: 30px;
    font-weight: 800;
    line-height: 1.25;
    color: #ffffff;
    margin: 0 0 12px 0;
    letter-spacing: -0.5px;
    
    @media (max-width: 768px) {
        font-size: 24px;
    }
`;

const ProductDescription = styled.p`
    font-size: 15px;
    line-height: 1.55;
    color: rgba(255, 255, 255, 0.7);
    margin: 0 0 20px 0;
    
    @media (max-width: 992px) {
        max-width: 600px;
    }
`;

const BulletList = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 12px;
    text-align: left;
`;

const BulletItem = styled.li`
    display: flex;
    align-items: flex-start;
    gap: 10px;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.8);
    line-height: 1.5;
`;

const BulletIcon = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: rgba(168, 85, 247, 0.15);
    color: #c084fc;
    font-size: 11px;
    font-weight: bold;
    flex-shrink: 0;
    margin-top: 2px;
`;

const StyledImage = styled.img`
    width: 100%;
    height: auto;
    border-radius: 12px;
    box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.37);
    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
    border: 1px solid rgba(255, 255, 255, 0.08);
    cursor: zoom-in;
    
    &:hover {
        transform: translateY(-4px) scale(1.01);
        box-shadow: 0 20px 38px rgba(123, 47, 206, 0.25);
        border-color: rgba(255, 255, 255, 0.2);
    }
`;

const VideoWrapper = styled.div`
    width: 100%;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.37);
    border: 1px solid rgba(255, 255, 255, 0.08);
`;

const ImageModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(10, 3, 20, 0.9);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 400000;
    cursor: zoom-out;
    animation: cdzvFadeIn 0.25s cubic-bezier(0.16, 1, 0.3, 1);
    
    @keyframes cdzvFadeIn {
        from { opacity: 0; backdrop-filter: blur(0px); -webkit-backdrop-filter: blur(0px); }
        to { opacity: 1; backdrop-filter: blur(12px); -webkit-backdrop-filter: blur(12px); }
    }
`;

const ImageModalContent = styled.div`
    position: relative;
    max-width: 90%;
    max-height: 90%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const ImageModalClose = styled.button`
    position: fixed;
    top: 20px;
    right: 20px;
    width: 44px;
    height: 44px;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    color: #ffffff;
    font-size: 22px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s ease, transform 0.2s ease;
    padding: 0;
    line-height: 1;
    z-index: 400001;
    
    &:hover {
        background: rgba(255, 255, 255, 0.2);
        transform: scale(1.1);
    }
`;

const ImageModalPicture = styled.img`
    max-width: 100%;
    max-height: 85vh;
    border-radius: 12px;
    background: #0c0614;
    padding: 16px;
    box-sizing: border-box;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);
    border: 1px solid rgba(255, 255, 255, 0.08);
    animation: cdzvScaleIn 0.2s cubic-bezier(0.34, 1.56, 0.64, 1);
    
    @keyframes cdzvScaleIn {
        from { transform: scale(0.95); opacity: 0; }
        to { transform: scale(1); opacity: 1; }
    }
`;

const CdzvToolkitRU = () => {
    const [activeTab, setActiveTab] = React.useState("image");
    const [isModalOpen, setIsModalOpen] = React.useState(false);

    React.useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Escape") setIsModalOpen(false);
        };
        if (isModalOpen) {
            document.addEventListener("keydown", handleKeyDown);
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
            document.body.style.overflow = "";
        };
    }, [isModalOpen]);

    return (
        <ShowcaseContainer>
            <ContentColumn>
                <ProductTag>Бесплатный инструмент</ProductTag>
                <ProductTitle>CDZV Toolkit</ProductTitle>
                <ProductDescription>
                    Основной визуальный конструктор стратегий без кода. Создавайте любой собственный торговый алгоритм прямо на графике TradingView абсолютно бесплатно и автоматизируйте свою работу.
                </ProductDescription>
                <BulletList>
                    <BulletItem>
                        <BulletIcon>✓</BulletIcon>
                        <div>
                            <strong>Визуальный конструктор без кода:</strong> Собирайте и объединяйте сложные условия входа и выхода прямо на графике.
                        </div>
                    </BulletItem>
                    <BulletItem>
                        <BulletIcon>✓</BulletIcon>
                        <div>
                            <strong>Мгновенное тестирование идей:</strong> Протестируйте каждый алгоритм на истории рынка за несколько лет перед тем, как рисковать реальными деньгами.
                        </div>
                    </BulletItem>
                    <BulletItem>
                        <BulletIcon>✓</BulletIcon>
                        <div>
                            <strong>Полная автоматизация 24/7:</strong> Запустите стратегию в облаке — она будет торговать сама, даже когда ваш компьютер или телефон выключены.
                        </div>
                    </BulletItem>
                </BulletList>
            </ContentColumn>
            <MediaColumn>
                <TabContainer>
                    <TabButton active={activeTab === "video"} onClick={() => setActiveTab("video")}>
                        <svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'><polygon points='23 7 16 12 23 17 23 7'></polygon><rect x='1' y='5' width='15' height='14' rx='2' ry='2'></rect></svg> Видео-обзор
                    </TabButton>
                    <TabButton active={activeTab === "image"} onClick={() => setActiveTab("image")}>
                        <svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'><rect x='3' y='3' width='18' height='18' rx='2' ry='2'></rect><circle cx='8.5' cy='8.5' r='1.5'></circle><polyline points='21 15 16 10 5 21'></polyline></svg> Схема
                    </TabButton>
                </TabContainer>
                
                {activeTab === "video" ? (
                    <VideoWrapper>
                        <QuarklycommunityKitYouTube 
                            url="https://www.youtube.com/watch?v=bEvSWtGzcZs" 
                            modestbranding={true}
                            showOverlay={true}
                        />
                    </VideoWrapper>
                ) : (
                    <StyledImage src={toolkitImg} alt="CDZV Toolkit" onClick={() => setIsModalOpen(true)} />
                )}
            </MediaColumn>
            
            {isModalOpen && (
                <ImageModalOverlay onClick={() => setIsModalOpen(false)}>
                    <ImageModalContent onClick={(e) => e.stopPropagation()}>
                        <ImageModalClose onClick={() => setIsModalOpen(false)} aria-label="Close">
                            &times;
                        </ImageModalClose>
                        <ImageModalPicture src={toolkitImg} alt="CDZV Toolkit" />
                    </ImageModalContent>
                </ImageModalOverlay>
            )}
        </ShowcaseContainer>
    );
};

const Wrapper = props => {
    return (
        <SectionWrapper {...props}>
            <CdzvToolkitRU />
        </SectionWrapper>
    );
};

export default Wrapper;